import React, { useState,useEffect,useRef,useCallback } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,color,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react';
import parse from 'html-react-parser';
import QRCode from "react-qr-code";
import '../lib/bootstrap.min.css'
import './Main.css';
import './RoomService.css';

const Helpdesk = (props) => {

    const ref = useRef(null);
    const refContent = useRef(null);
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)
    const [loading,setLoading] = useState(false)
    const [emblaRef, emblaApi] = useEmblaCarousel({ axis: 'y' })
    const [prevDisable,setPrevDisable] = useState(false)
    const [nextDisable,setNextDisable] = useState(false)

    
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev()
          //setPrevDisable(!emblaApi.canScrollPrev)
          //setNextDisable(!emblaApi.canScrollNext)
      }, [emblaApi])
    
      const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext()
          //setPrevDisable(!emblaApi.canScrollPrev)
          //setNextDisable(!emblaApi.canScrollNext)
      }, [emblaApi])
      const scrolTo = useCallback((index) => {
          if (emblaApi) emblaApi.scrollTo(index)
        }, [emblaApi])
  
        

    useEffect(() => {
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
    }, []);

  return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-helpdesk'
                    style={{height:(props.height)+'px', padding:'0px'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <Row>
                        <Col md={3} className='ch-left' style={{height:(props.height)+'px'}}>
                            <motion.div style={{margin:'0px', width:'100%'}}>
                                <Row>
                                <Col sm={4} style={{margin:0,padding:0}}>
                                    <div className='helpPhoto'>
                                        <img src='/images/helpdesk.png' />
                                    </div>
                                </Col>
                                <Col sm={8} style={{margin:0,padding:0}}>
                                    <div className='helpTitle'>
                                        <h2>Room Service</h2>
                                        <h3>Dashboard</h3>
                                    </div>
                                </Col>
                                <Col sm={12}>
                                    {props.reservation != null && (
                                        <div className='helpQr'>
                                                <QRCode 
                                                    value={props.user.domain_mob+`/` + props.reservation.reservation_active[0].reservation_key} 
                                                    style={{
                                                        background:'#ffffff',
                                                        padding:5,
                                                        marginBottom:15,
                                                        width:80,
                                                        height:80
                                                    }} />
                                                
                                                <h5 style={{fontSize:14}}>Scan QR <br />to open the app</h5>
                                        </div>
                                    )}
                                </Col>
                                </Row>
                                
                            </motion.div>
                        </Col>
                        <Col md={9} style={{height:(props.height)+'px', overflow:'hidden', padding:'20px 30px'}}>
                            <motion.div ref={refContent}>
                                    <div className='tabHeader'>
                                        <table style={{width:'100%'}} className='tabHHelpdesk'>
                                            <thead>
                                                <tr>
                                                    <td width={'15%'}>Date</td>
                                                    <td width={'40%'}>Description</td>
                                                    <td width={'25%'}>Status</td>
                                                    <td width={'20%'}>Note</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className="embla_helpdesk" style={{height:height-70}}>
                                        <div className="embla__viewport_helpdesk" ref={emblaRef} style={{height:height-130}} onFocus={()=>{document.getElementById('next').focus()}}>
                                            <div className="embla__container_helpdesk" style={{height:height-135}}>

                                                { props.roomServices && props.roomServices.map((service,key)=>(
                                                    <>
                                                    {key%2 == 0 ? (
                                                        <div className="embla__slide_helpdesk" style={{height:height-150, paddingTop:0, marginBottom:0, backgroundColor: 'rgba(50, 15, 0, 0.6)'}} key={key}>
                                                            <table style={{width:'100%'}} className='tabCHelpdesk'>
                                                                <tbody>
                                                                    <tr>
                                                                        <td width={'15%'} valign='top' align='left'>{
                                                                            parse("Open <br/> " + 
                                                                            new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.open)))
                                                                        }</td>
                                                                        <td width={'40%'} valign='top' align='left'>{service.description}</td>
                                                                        <td width={'15%'} valign='top' align='left'>
                                                                            {service.closed != null ? (
                                                                                parse("Closed <br/> " + 
                                                                                new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.closed)))
                                                                            ):(
                                                                                service.responded != null && (
                                                                                    parse("Responded <br /> " + 
                                                                                    new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.responded)))
                                                                                )
                                                                            )}
                                                                        </td>
                                                                        <td width={'30%'} valign='top' align='left'>
                                                                            {service.closed != null ? (
                                                                                service.closed_note
                                                                            ):(
                                                                                service.responded != null && (
                                                                                    service.responded_note
                                                                                )
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="embla__slide_helpdesk" style={{height:height-150, paddingTop:0, marginBottom:0}} key={key}>
                                                            <table style={{width:'100%'}} className='tabCHelpdesk'>
                                                                <tbody>
                                                                    <tr>
                                                                        <td width={'15%'} valign='top' align='left'>{
                                                                            parse("Open <br/> " + 
                                                                            new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.open)))
                                                                        }</td>
                                                                        <td width={'40%'} valign='top' align='left'>{service.description}</td>
                                                                        <td width={'15%'} valign='top' align='left'>
                                                                            {service.closed != null ? (
                                                                                parse("Closed <br/> " + 
                                                                                new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.closed)))
                                                                            ):(
                                                                                service.responded != null && (
                                                                                    parse("Responded <br /> " + 
                                                                                    new Intl.DateTimeFormat('en-US', {hour12: false,month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(service.responded)))
                                                                                )
                                                                            )}
                                                                        </td>
                                                                        <td width={'30%'} valign='top' align='left'>
                                                                            {service.closed != null ? (
                                                                                service.closed_note
                                                                            ):(
                                                                                service.responded != null && (
                                                                                    service.responded_note
                                                                                )
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )} 
                                                    
                                                    </>
                                                 ))}
                                                
                                            </div>
                                        </div>
                                        <div className='embla__nav__helpdesk'>
                                            <button id='prev' className="embla__prev btnFNB" onClick={scrollPrev} disabled={prevDisable}>
                                                &laquo; Prev
                                            </button>
                                            <button id='next' className="embla__next btnFNB" onClick={scrollNext} disabled={nextDisable}>
                                                Next &raquo;
                                            </button>
                                        </div>
                                    </div>
                            </motion.div>
                            
                        </Col>
                    </Row>
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Helpdesk;


